import { render, staticRenderFns } from "./related-prompts-metrics.component.vue?vue&type=template&id=36bde494&scoped=true"
import script from "./related-prompts-metrics.component.vue?vue&type=script&lang=ts"
export * from "./related-prompts-metrics.component.vue?vue&type=script&lang=ts"
import style0 from "./related-prompts-metrics.component.vue?vue&type=style&index=0&id=36bde494&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36bde494",
  null
  
)

export default component.exports